import { useLocation } from "@tanstack/react-router"

import { useCabinetAccess } from "../access/use-access"
import { sectionByPath } from "./nav-items"
import { type BranchSelection, resolveSelection, useBranchMemory } from "./use-branch"

/**
 * Филиал, выбранный в шапке, — РОВНО ТАК, КАК ЕГО СЧИТАЕТ ОБОЛОЧКА.
 *
 * Раздел, которому филиал не приходит адресом, обязан брать его отсюда, а не угадывать
 * заново. Центр уведомлений считал дела без филиала, а колокольчик в той же шапке —
 * с филиалом: в шапке «2», над лентой «Требуют действия: 7», и переключатель филиала
 * над лентой не менял ничего (разбор wwtalq62e, находка 14). Одна функция на оболочку
 * и на экран — и два числа не могут разойтись.
 *
 * Параметр `branch` читается из строки адреса, а не из типизированного search маршрута:
 * он есть не у каждого раздела, и знать, у какого, ни оболочке, ни экрану незачем.
 * Подписка на память устройства — чтобы выбор в шапке доезжал до разделов без адреса.
 */
export function useShellBranchSelection(): BranchSelection {
  const { context } = useCabinetAccess()
  useBranchMemory()
  const pathname = useLocation({ select: (location) => location.pathname })
  const searchStr = useLocation({ select: (location) => location.searchStr })
  const wanted = new URLSearchParams(searchStr).get("branch")
  const allowsAll = sectionByPath(pathname)?.allowsAllBranches ?? true
  return resolveSelection(context, wanted, allowsAll)
}
